export default __webpack_public_path__ + "static/media/Avalanche.fbe749a6.png";